<template>
  <Modal v-on:close="close" :redesign="true">
    <div slot="header">
      <h3 class="modal-title">{{ $tr('settings.managers.editUser.title') }}</h3>
    </div>
    <div slot="body" class="basic-form">
      <div class="row-block">
        <template v-if="!is_japan_locale">
          <label>{{ $tr('settings.managers.addUser.name') }}*</label>
          <input type="text"
            name="name" v-validate="'required|alpha_spaces'" :class="{'error': errors.has('name') }"
            v-model="user.name" :placeholder="$tr('settings.managers.addUser.placeholders.name')" />
        </template>
        <template v-else>
          <label>{{ $tr('settings.managers.addUser.surname') }}*</label>
          <input type="text"
            name="surname" v-validate="'required|alpha_spaces'" :class="{'error': errors.has('surname') }"
            v-model="user.surname" :placeholder="$tr('settings.managers.addUser.placeholders.surname')" />
        </template>
      </div>

      <div class="row-block">
        <template v-if="!is_japan_locale">
          <label>{{ $tr('settings.managers.addUser.surname') }}*</label>
          <input type="text"
            name="surname" v-validate="'required|alpha_spaces'" :class="{'error': errors.has('surname') }"
            v-model="user.surname" :placeholder="$tr('settings.managers.addUser.placeholders.surname')" />
        </template>
        <template v-else>
          <label>{{ $tr('settings.managers.addUser.name') }}*</label>
          <input type="text"
            name="name" v-validate="'required|alpha_spaces'" :class="{'error': errors.has('name') }"
            v-model="user.name" :placeholder="$tr('settings.managers.addUser.placeholders.name')" />
        </template>
      </div>

      <div class="row-block">
        <label>{{ $tr('settings.managers.addUser.email') }}*</label>
        <input type="email"
               name="email" v-validate="'required|email'" :class="{'error': errors.has('email') }"
               v-model="user.email" :placeholder="$tr('settings.managers.addUser.placeholders.email')" />
        <span v-if="error_email">{{ error_email }}</span>
      </div>

      <div class="row-block">
        <label>{{ $tr('profile.profileForm.info.position') }}</label>
        <input type="text"
               name="position" :class="{'error': errors.has('position') }"
               v-model="user.position" />
      </div>

      <div class="row-block">
        <label>{{ $tr('settings.managers.addUser.phone') }}</label>
        <vphone class="phone-input"
          v-model="user.phone"
          :border="true"
          :class="{'error': !phone_valid}"
          :let_empty="true"
          @valid="phone_valid = $event"
        />
      </div>

      <div class="row-block">
        <label>{{ $tr('settings.managers.addUser.skype') }}</label>
        <input type="text"
               v-model="user.skype" :placeholder="$tr('settings.managers.addUser.placeholders.skype')" />
      </div>

      <div class="row-block">
        <label>{{ $tr('settings.managers.addUser.region') }}*</label>

        <CitySelect
          class="city-select"
          :selectedGeo="user && user.geo ? user.geo : {}"
          :getAddressData="getAddressData"
          :deleteGeo="deleteGeo"
        />
      </div>
    </div>
    <div slot="footer">
      <vbutton
        label="settings.managers.editUser.save"
        :disabled="!valid"
        @click="saveUser" />
    </div>
  </Modal>
</template>

<script>
  import Modal from '@/components/Modal.vue'
  import CitySelect from '@/components/shared/CitySelect.vue'

  import { directive as VueClickAway } from 'vue-clickaway'

  import { getCountryCodeFromPlaceID } from '@/components/invites/creation/CORSrequest.js'
  import { get_address } from '@/_helpers/utils'
  import AlphaSpaceValidator from '@/_helpers/AlphaSpaceValidator.js'

  export default {
    name: 'modal-edit-user',

    directives: {
      onClickAway: VueClickAway
    },

    components: {
      Modal,
      CitySelect
    },

    props: {
      userToEdit: Object
    },

    data () {
      return {
        showModal: false,
        user: {
          name: '',
          email: '',
          position: '',
          phone: '',
          skype: '',
          geo: {
            place_id: null,
            description: null
          }
        },
        phone_valid: false,
        userCountry: ''
      }
    },

    watch: {
      placeId (val) {
        if (val && !this.user.phone) {
          this.geoRequest(val)
        }
      }
    },

    computed: {
      valid () {
        const fields = Object.keys(this.fields).map(k => this.fields[k])
        const geoValid = this.user.geo ? this.user.geo.place_id : false

        return fields.every(f => f.valid === true) && geoValid && this.phone_valid
      },

      locale () {
        return this.$store.getters['locale/current']
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },
  
      placeId () {
        const geo = this.user ? this.user.geo : null
  
        return geo ? geo.place_id : null
      },

      error() {
        return this.$store.getters['users/error'];
      },

      error_details() {
        return this.error ? this.error.details : null
      },

      error_email() {
        return this.error_details ? this.error_details.new_email[0] : ''
      }
    },

    methods: {
      geoRequest (placeId) {
        const locale = this.locale;
        getCountryCodeFromPlaceID(placeId, locale)
          .then(res => {
            this.userCountry = res
          })
          .catch(err => { console.log(err) })
      },

      close () {
        this.$emit('close')
      },

      getAddressData (addressData, placeResultData) {
        this.user.geo = get_address(addressData, placeResultData)
      },

      deleteGeo () {
        this.user.geo = {
          place_id: null,
          description: null
        }
      },

      saveUser () {
        if (!this.valid) {
          return
        }
        const user = Object.assign({}, {
          ...this.user,
          email: this.userToEdit.email,
          new_email: this.user.email
        })
        this.$store.dispatch('users/updateUsers', [user])
          .then(() => this.$store.dispatch('users/fetchUsers'))
          .then(() => this.$emit('dismiss'))
          .then(() => this.close())
          .catch(err => {
            this.$noty.error(err.message);
          })
      }
    },

    beforeMount () {
      this.user = {...this.userToEdit}
      if (this.placeId) {
        this.geoRequest(this.placeId)
      }
    },

    created () {
      this.$validator.extend('alpha_spaces', AlphaSpaceValidator.validator)
    },

    beforeDestroy() {
      this.$store.commit('users/set_error', null);
    }
  }
</script>

<style scoped lang="scss">
  .city-select {
    width: 100%;
  }

  .phone-input {
    width: 100%;
  }

  .basic-form {
    .row-block {
      margin-bottom: 5px;
      min-height: 82px;
      flex-direction: column;

      label {
        width: auto;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 6px;
        font-size: 14px;
        line-height: 16px;
        font-weight: 600;
        color: #7f7f7f;
      }

      input {
        width: 100%;
        font-size: 16px;
        margin: 0;
        display: block;
      }

      span {
        color: #f65046;
        line-height: 19px;
        font-size: 13px;
        margin-top: 5px;
        margin-left: 10px;
      }
    }
  }
</style>
